import React from 'react';
import classNames from 'classnames';
import './index.less';

export interface ITitleProps {
  className?: string;
  required?: boolean;
  textClassName?: string;
  labelWidth?: string | number;
}

export interface ITitleState {

}

class Title extends React.Component<ITitleProps, ITitleState> {
  static defaultProps = {
    labelWidth: 'auto'
  };
  renderStar() {
    const { required } = this.props;
    if (!required) { return null; }
    return (
      <span className="base-title-star">*</span>
    );
  }

  render() {
    const { className, children, textClassName, labelWidth } = this.props;
    const classes = classNames('base-title', className);
    const textClazzName = classNames('base-title-text', textClassName);
    return (
      <div className={classes}>
        {this.renderStar()}
        <span className={textClazzName} style={{width: labelWidth}}>{children}</span>
      </div>
    );
  }
}

export default Title;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/account/Resume/components/Title/index.tsx